import { QueryColumn } from "query/QueryColumn";
import { Cell, CellType } from "table/Cell";
import { Row } from "table/Row";
import { ExpanderIterator } from "./ExpanderIterator";

/* I output a Cell in a Row once, and then keep filling in the rest of the invocations
   with blanks.
*/
export class SingleValueExpanderIterator extends ExpanderIterator {
    private _source: Cell = new Cell();

    constructor(column: QueryColumn, columnNumber: number) {
        super(column, columnNumber);
    }

    public nextInto = (accumulator: Row) => {
        this.nextIntoImpl(accumulator, this._column, this._source);
        this._isExhausted = true;
    };

    private nextIntoImpl = (accumulator: Row, column: QueryColumn, value: Cell) => {
        if (column.isExpanded && column.children().length > 0) {
            // TODO: What? SingleValueExpanderIterators should not have children.
            console.debug("What? SingleValueExpanderIterators should not have children.");
            /* DELETE ME. I don't know why this code is here.
            for (let i = 0; i < column.children().length; i++) {
                let childColumn: QueryColumn = column.children()[i];
                if (value && childColumn && childColumn.name) {
                    let childValue = value[childColumn.name];
                    this.nextIntoImpl(accumulator, childColumn, childValue);
                } else {
                    if (!value) {
                        console.error(`Value for column ${childColumn?.name} is ${value}`);
                    } else if (!childColumn) {
                        console.error(`Column ${i} does not exist.`);
                    } else if (!childColumn.name) {
                        console.error(`Column ${i} has no name.`);
                    }
                }
            }*/
        } else {
            let c = new Cell();
            c._type = this._isExhausted ? CellType.EXHAUSTED : CellType.SINGLE;
            if (!value) {
                console.error(`Value is ${value}`);
                // put a breakpoint here.
            } else {
                c._value = value._value
            }
            accumulator.cells.push(c);
        }
    }

    public isExhausted = () => {
        return this._isExhausted;
    }

    public replenishWith = (source: Cell) => {
        if (undefined === Cell) {
            // This only happens for CollectionExpanderIterators.
            throw new Error("SingleValueExpanderIterators cannot be replenished with undefined.");
        } else {
            this._source = source as Cell;
        }
        this._isExhausted = false;
    }

    /** If data was missing from the server's response, this is invoked instead of replenishWith. For unexpanded collections, this is normal. */
    public noDataAvailable = () => {
        let filler: Cell = new Cell();
        filler._type = CellType.EXHAUSTED;
        this.replenishWith(filler);
        this._isExhausted = true;
    }
}